import { useFeatureChecks } from './feature-context';

/**
 * Hook to get comment length constraints based on feature toggles
 * @returns {Object} Comment constraints with maxLength
 */
export const useCommentConstraints = () => {
    const { useFeature } = useFeatureChecks();

    // Get feature-toggled max comment length (default 4000 from backend)
    const maxLength = useFeature('evidence.comments.maxLength', 4000);

    return {
        maxLength,
    };
};
